<template>
    <div>
        <div>
            <v-easy-camera v-model="picture"></v-easy-camera>
        </div>
        <div class = "button">
            <b-button to="/add">Confirm</b-button>
            <b-button to="/">Close</b-button>
        </div>
    </div>
</template>

<script>
// Citation: easy-vue-camera Version 1.0.5 https://openbase.com/js/easy-vue-camera
import EasyCamera from 'easy-vue-camera';

export default {
  name: 'Camera',
  components: {
    'v-easy-camera': EasyCamera
  }
}

</script>

<style>
    .button {
        z-index:999;
        position:fixed;
        bottom: 10;
    }
</style>